import React from "react";
import BaseView from "../common/BaseView";
import { columns } from "./config";
import { getStalledLeads } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="Stalled Leads"
      subtitle="These are companies that stalled prior to completing the application process. Every effort is done to revive these opportunities, and we will notify you immediately when that happens."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getStalledLeads);
